import {useEffect, useState} from "react";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {RaikoAlert, raikoAlertTypes} from "../../raikoComponents/raikoAlert/RaikoAlert";
import RaikoSimpleInputOutlined from "../../raikoComponents/raikoCustomInput/RaikoSimpleInputOutlined";
import RaikoSimpleMultiLineInputOutlined
    from "../../raikoComponents/raikoCustomInput/RaikoSimpleMultiLineInputOutlined";
import SeoSchemaCreator from "./SeoOpenGraphCreator";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import PropTypes from "prop-types";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";

export default function SeoComponent(
    {
        id,
        serviceInstance: service
    }) {

    useEffect(() => {
        if (typeof id !== 'undefined' && id >= 0) {
            try {
                loading.show()
                service.getSeo(id)
                    .then(response => {
                        setMetaTitle(response.metaTile)
                        setMetaDescription(response.metaDescription)
                        setMetaRobots(response.metaRobots)
                        setMetaKeyboards(response.metaKeyboards)
                        setOpenGraph(response.openGraphItems)

                    }).catch(reason => {

                    snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت جزئيات سئو"))
                }).finally(_ => {

                    loading.hide()
                })
            } catch (e) {
                if (typeof service === 'undefined') {
                    console.error("Service not declared, please declare service and send it to component by props before use seo component ...")
                } else if (typeof service.getSeo === 'undefined') {
                    console.error("Cant find getSeo function in service, please declare it for get seo info from server ...")
                }
            }
        }
    }, [id])

    const snackbar = new SnackbarHelper(useSnackbarDispatcher())
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [metaTitle, setMetaTitle] = useState("");
    const [metaDescription, setMetaDescription] = useState("");
    const [metaRobots, setMetaRobots] = useState("");
    const [metaKeyboards, setMetaKeyboards] = useState("");
    const [openGraph, setOpenGraph] = useState([]);

    function handleUpdateInfo() {
        try {
            loading.show()
            service.updateSeo(
                id,
                metaTitle,
                metaDescription,
                metaRobots,
                metaKeyboards,
                openGraph
            ).then(response => {
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در بروزرسانی اطلاعات سئو سایت"))
            }).finally(_ => {
                loading.hide()
            })
        } catch (e) {
            snackbar.showWarningMessage("خطا در بروزرسانی اطلاعات سئو")

            if (typeof service === 'undefined') {
                throw "Service not declared, please declare service and send it to component by props before use seo component ..."
            } else if (typeof service.updateSeo === 'undefined') {
                throw "Cant find updateSeo function in service, please declare it for update seo items ..."
            } else
                throw e
        }
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoAlert
                    type={raikoAlertTypes.info}
                    title={"بهینه سازی موتور های جستجو"}
                    description={[
                        "* برای بهتر دیده شدن مقاله ی خود در موتور های جستجو باید مقاله را به بهترین روش ممکن به موتور های جستجو معرفی نمایید.",
                        "* متا ها ابزار هایی برای معرفی صحیح صفحات و محتواهای آن ها به موتور های جستجو هستند."
                    ]}
                />
                <RaikoSimpleInputOutlined
                    labelText={"Meta Title"}
                    setValue={setMetaTitle}
                    value={metaTitle}/>
                <RaikoSimpleMultiLineInputOutlined
                    labelText={"Meta Description"}
                    setValue={setMetaDescription}
                    value={metaDescription}/>
                <RaikoSimpleInputOutlined
                    labelText={"Meta Robots"}
                    setValue={setMetaRobots}
                    value={metaRobots}/>
                <RaikoSimpleInputOutlined
                    labelText={"Meta Keyboard"}
                    setValue={setMetaKeyboards}
                    value={metaKeyboards}/>
                <SeoSchemaCreator
                    schema={openGraph}
                    setSchema={setOpenGraph}
                />

                <ButtonDivisionSection>
                    <ButtonPrimaryRaiko label={"بروزرسانی"} onClick={handleUpdateInfo}/>
                </ButtonDivisionSection>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}

SeoComponent.propTypes = {
    id: PropTypes.any.isRequired,
    serviceInstance: PropTypes.object.isRequired
}
